import React, { Component } from 'react';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
import InfoIcon from '@material-ui/icons/Info';
import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField/index';
import {insertSubmit} from '../../../../../../services/InsertSubmit'
import Typography from '@material-ui/core/Typography';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CloseIcon from '@material-ui/icons/Close';
import {deleteHistoric} from '../../../../../../services/deleteSubmit'
import {getObjectiveAvailabilityResponseMonth} from '../../../../../../services/getObjectiveAvailabilityResponse'
moment.locale('es')

class WindowModalMonthDelete extends Component {

    
    constructor(props) {
        super(props);
        // console.log(props)
        var requiredOut=false
        var requiredError=false
        if(props.row.fuera===0){
            requiredOut=true
        }
        if(props.row.error===0){
            requiredError=true
        }
        sessionStorage.setItem("data", JSON.stringify(this.props.row))
        this.state = {
            dataObjective:this.props.dataObjective,
            mes:this.props.row.mes,
            perf:this.props.row.perf,
            error:this.props.row.error,
            out:this.props.row.fuera,
            sample:this.props.row.muestra,
            data:this.props.row,
            errorValue:false,
            average:this.props.row.tiempo,
            msg:["Valores Ingresados deben tener como Resultado 100%"], 
            indexmsg:0,
            fieldChange:'',
            OutRequired:requiredOut,
            ErrorRequired:requiredError,
            sampleRequired:false,
            openPop:false,
            anchorPop:null,
            prevData:this.props.prevData
        }
    }

    insertHistoric=()=>{    
        const {prevData,mes}=this.state
        const months = [
            {id: '00', month: 'Enero'},
            {id: '01', month: 'Enero'},
            {id: '02', month: 'Febrero'},
            {id: '03', month: 'Marzo'},
            {id: '04', month: 'Abril'},
            {id: '05', month: 'Mayo'},
            {id: '06', month: 'Junio'},
            {id: '07', month: 'Julio'},
            {id: '08', month: 'Agosto'},
            {id: '09', month: 'Septiembre'},
            {id: '10', month: 'Octubre'},
            {id: '11', month: 'Noviembre'},
            {id: '12', month: 'Diciembre'},
          ];
          
        let monthId = ''
        let nextMonthId = ''
        months.reduce((ids, value) => {
          if (value.month === mes) {
            monthId = value.id
            nextMonthId = parseInt(value.id) + 1
          }
        });
                 
        const date = new Date();    
        const year = date.getFullYear();

        let begin = year + "-" + monthId + '-01'
        let final = year + "-0" + nextMonthId + '-01'

        getObjectiveAvailabilityResponseMonth(prevData.user,begin, final,prevData.showObjective.objetivo_id, prevData.step.id_paso, prevData.sla_p, 29)
        .then( data => {
            this.props.handleCloseControl()
            this.setState({
                errorValue:false
            });
        })
        this.props.handleControl(mes)
        this.close()
        
    }

  
    recoverHistoric=()=>{             
        const {mes,perf,error,out,dataObjective}=this.state
       
        deleteHistoric(dataObjective.objetivo_id,mes,perf,error,out)
        .then( data => {
            this.props.handleCloseControl()
            this.setState({
                errorValue:false
            });
        })

        this.insertHistoric()

        this.props.handleControl(mes)
        this.close()
        
    }

    close=()=>{
        this.props.handleCloseControl()
    }
  
    handlePopover=(event)=>{
        this.setState(prevState => ({
            openPop: !prevState.openPop,
            anchorPop:event.currentTarget
        }));
        
    }
    

    render() {
        const {classes}= this.props
        const {mes} =this.state
        return(
        <Grid
            container
            spacing={1}
            style={{backgroundColor:"white", width:"35%"}}
        >
          
            <Grid
                item
                xs={2}
                sm={2}
                md={2}
                xl={2}
                style={{textAlign:"right"}}
            >
                <Button onClick={this.close}><CloseIcon/></Button>
            </Grid>           
           
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
            >
                <Typography>¿ esta seguro de restablecer valor para el mes {mes}?</Typography>
            </Grid>
            
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
            >
                <Button onClick={this.recoverHistoric} className={classes.button}>Aceptar</Button>
            </Grid>
        </Grid>
    )
        
    }
}



//export default (Movistar);

export default compose(withStyles(styles))(WindowModalMonthDelete);


// WEBPACK FOOTER //
// ./src/layouts/components/content/Control/ControlMonthObjective/WindowModalMonthDelete/index.jsx